
import Paginate from '@app/vue/Paginator/index.vue';
import { PropType } from 'vue';
import ChunkCollection from "modules/spravochnik/dt-front-page-generator/src/Utils/ChunkCollection";
import {v4 as uuid} from "uuid";

export default {
    components: {Paginate},
    props: {
        list: {
            type: Object as PropType<ChunkCollection<any>>,
        },
        modelValue: {
            type: Number,
        },
        count: {
            type: Number,
            default: 20,
        }
    },
    emits: ['changePage'],
    computed: {
        show() {
            return this.list.total > this.count;
        },
        forcePage() {
            const page = this.$route.query.page;
            if (page) {
                return parseInt(page, 10);
            }
            return undefined;
        }
    },
    watch: {
        modelValue() {
            this.key = uuid();
        },
    },
    methods: {
        changePage(pageNumber: number): void {
            window.scrollTo({
              top: 0,
              behavior: 'smooth'
            });

            this.$emit('changePage', pageNumber);
        }
    },
    mounted() {

    },
    data() {
        return {
            key: uuid(),
        }
    }
}
